import {SummaryModel} from '../../../../entity/summary.model';
import {PermissionsModel} from '../../../../entity/permissions.model';
import {LovListModelModel} from './lovListModel.model';

export class LovListSummary implements SummaryModel {
    id: number;
    name: string;
    label: string;
    model: LovListModelModel;
    permissions: PermissionsModel;
}
